// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
    max-width: 100%;
}

.welcome_box h1 {
    font-size: 34px;
    font-weight: 300;
    color: #455A64;
    line-height: 1.5;
}

h1 span {
    font-weight: 600;
}

p {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.8;
    color: #455A64;
}

.congo_box {
    background-color: #2962FF;
    border-radius: 20px;
    padding: 20px;
}


.congo_box .star_div i {
    color: #2962FF;
    font-size: 20px;
}

.congo_box .star_div {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #fff;
}

.congo_box h2 {
    font-size: 19px;
    font-weight: 600;
}

.btn.main_white_btn {
    background-color: #fff;
    color: #000;
    border: 0;
    box-shadow: none !important;
    padding: 12px 20px;
    border-radius: 12px;
    font-weight: 500;
}

.white_box {
    background-color: #fff;
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    border-radius: 20px;
    padding: 21px;
}

.white_box p {
    font-weight: 400;
    font-size: 14px;
    color: #455A64;
}

.white_box h3,
.meeting_box h3 {
    font-weight: 600;
    font-size: 22px;
    color: #455A64;
}

.white_box.targetbox h3,
.meeting_box h3 {
    font-size: 19px;
}



.stat_box h5 {
    font-weight: 600;
    font-size: 26px;
    color: #0a2e2e;
}

.stat_box p {
    font-weight: 500;
    font-size: 18px;
    color: #455a64;
}

.stat_box i.stats_arrow {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translate(0, -50%);
}

i.fa-angle-right {
    font-size: 21px;
    color: #455a64;
}

.stat_box i.fa-caret-up.stats_arrow {
    color: #00DE72;
}

.stats_list:nth-child(2) span {
    background-color: #FF3D00;
}


.stats_list:last-child span i.fa-smile-o {
    font-size: 22px;
}

.stats_list:last-child span .fa-caret-down {
    color: #FF3D00;
}

.dashboard_card .stat_box.white_box span {
    width: 57px;
    height: 57px;
    border-radius: 50%;
}

.dashboard_card:nth-child(5n+1) .stat_box.white_box {
    background: #FFE2E5;
}

.dashboard_card:nth-child(5n+1) .stat_box.white_box span {
    background-color: #FA5A7D;
}

.dashboard_card:nth-child(5n+2) .stat_box.white_box {
    background: #FFF4DE;
}

.dashboard_card:nth-child(5n+2) .stat_box.white_box span {
    background-color: #FF947A;

}

.dashboard_card:nth-child(5n+3) .stat_box.white_box {
    background: #DCFCE7;
}

.dashboard_card:nth-child(5n+3) .stat_box.white_box span {
    background-color: #3CD856;

}

.dashboard_card:nth-child(5n+4) .stat_box.white_box {
    background: #F3E8FF;
}

.dashboard_card:nth-child(5n+4) .stat_box.white_box span {
    background-color: #BF83FF;

}

.dashboard_card:nth-child(5n+5) .stat_box.white_box {
    background: #c5e5ff;
}

.dashboard_card:nth-child(5n+5) .stat_box.white_box span {
    background-color: #3799e7;

}



.dashboard_card .stat_box.white_box span i {
    font-size: 25px;
}

/* .stat_box span {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    background-color: #2962FF;
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translate(0, -50%);
} */
/* .stat_box span {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    background-color: #2962FF;
    position: absolute;
    left: 50px;
    top: 46%;
    transform: translate(0, -50%);
} */

/* .stat_box span i {
    font-size: 18px;
} */

.view_dashboard {
    background-color: #ECEFF1;
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    border-radius: 20px;
    padding: 27px 15px 27px 77px;
}

.view_dashboard i {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translate(0, -50%);
    color: #455A64;
}

.view_dashboard p {
    font-weight: 500;
    font-size: 15px;
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #455A64;
}

.targetbox h5 {
    font-weight: 500;
    font-size: 15px;
    color: #455A64;
}

.view_dashboard .view_dashbard_icon {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    background-color: #fff;
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translate(0, -50%);
}

.targetnum:first-child .progress {
    background-color: #2962FF;
}

.views_target .progress {
    background-color: #2962ff29;
    border-radius: 100px;
    height: 13px;
}

.progress-bar {
    background-color: #2962FF;

}

.followers_target .progress {
    background-color: #fdc10733;
    border-radius: 100px;
    height: 13px;
}

.followers_target .progress-bar {
    background-color: #fdc107;
}

.income_target .progress {
    border-radius: 100px;
    height: 13px;
    background-color: #fb3d005c !important;
}

.income_target .progress-bar {
    background-color: #fb3d00 !important;
}

.meeting_box .stat_box span img {
    width: 42px;
    height: 42px;
    object-fit: cover;
    border-radius: 100%;
}

.meeting_box .stat_box span {
    background-color: transparent;
}

.meeting_box .stat_box h5 {
    font-size: 15px;
    width: 85%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.meeting_box .fa-plus {
    font-weight: 400;
    font-size: 22px;
    color: #232323;
}

.illustrator_img img {
    max-width: 230px;
    margin: auto;
}

.meeting_box .stat_box.white_box {
    padding: 23px 15px 23px 77px;
}

.btn.action_btn i {
    width: 43px;
    height: 43px;
    background-color: #0d6efd14;
    border-radius: 100%;
    display: inline-flex;
    justify-content: center;
    color: #434343;
    align-items: center;
    font-size: 18px;
}

.table-responsive th {
    padding: 15px 13px !important;
    color: #0a2e2e !important;
    font-weight: 500;
}

.table-responsive td {
    padding: 12px 13px !important;
    /* text-transform: capitalize; */
    color: #666666 !important;
    font-size: 14px;
}

.table-striped>tbody>tr:nth-of-type(odd)>* {
    background-color: rgba(94, 177, 191, 0.1);
}

form {
    background-color: #fff;
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    border-radius: 20px;
    padding: 35px;
}

form .form-control {
    padding: 8px 10px;
}

@media (max-width:1199px) {
    .welcome_box h1 {
        font-size: 28px;
    }
}

@media (max-width:767px) {
    .welcome_box h1 {
        font-size: 39px;
        line-height: unset;
    }

    .congo_box,
    .white_box {
        margin-bottom: 20px;
    }
}

@media (max-width:375px) {
    .welcome_box h1 {
        font-size: 32px;
    }

    .congo_box,
    .white_box {
        margin-bottom: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Admin/Home/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;;AAGA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,gDAAgD;IAChD,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,eAAe;AACnB;;;;AAIA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;;AAE7B;;;;AAIA;IACI,eAAe;AACnB;;AAEA;;;;;;;;;GASG;AACH;;;;;;;;;GASG;;AAEH;;GAEG;;AAEH;IACI,yBAAyB;IACzB,gDAAgD;IAChD,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;IACtB,gDAAgD;IAChD,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,mBAAmB;IACvB;AACJ","sourcesContent":["img {\n    max-width: 100%;\n}\n\n.welcome_box h1 {\n    font-size: 34px;\n    font-weight: 300;\n    color: #455A64;\n    line-height: 1.5;\n}\n\nh1 span {\n    font-weight: 600;\n}\n\np {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.8;\n    color: #455A64;\n}\n\n.congo_box {\n    background-color: #2962FF;\n    border-radius: 20px;\n    padding: 20px;\n}\n\n\n.congo_box .star_div i {\n    color: #2962FF;\n    font-size: 20px;\n}\n\n.congo_box .star_div {\n    width: 50px;\n    height: 50px;\n    border-radius: 100%;\n    background-color: #fff;\n}\n\n.congo_box h2 {\n    font-size: 19px;\n    font-weight: 600;\n}\n\n.btn.main_white_btn {\n    background-color: #fff;\n    color: #000;\n    border: 0;\n    box-shadow: none !important;\n    padding: 12px 20px;\n    border-radius: 12px;\n    font-weight: 500;\n}\n\n.white_box {\n    background-color: #fff;\n    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);\n    border-radius: 20px;\n    padding: 21px;\n}\n\n.white_box p {\n    font-weight: 400;\n    font-size: 14px;\n    color: #455A64;\n}\n\n.white_box h3,\n.meeting_box h3 {\n    font-weight: 600;\n    font-size: 22px;\n    color: #455A64;\n}\n\n.white_box.targetbox h3,\n.meeting_box h3 {\n    font-size: 19px;\n}\n\n\n\n.stat_box h5 {\n    font-weight: 600;\n    font-size: 26px;\n    color: #0a2e2e;\n}\n\n.stat_box p {\n    font-weight: 500;\n    font-size: 18px;\n    color: #455a64;\n}\n\n.stat_box i.stats_arrow {\n    position: absolute;\n    right: 20px;\n    top: 50%;\n    transform: translate(0, -50%);\n}\n\ni.fa-angle-right {\n    font-size: 21px;\n    color: #455a64;\n}\n\n.stat_box i.fa-caret-up.stats_arrow {\n    color: #00DE72;\n}\n\n.stats_list:nth-child(2) span {\n    background-color: #FF3D00;\n}\n\n\n.stats_list:last-child span i.fa-smile-o {\n    font-size: 22px;\n}\n\n.stats_list:last-child span .fa-caret-down {\n    color: #FF3D00;\n}\n\n.dashboard_card .stat_box.white_box span {\n    width: 57px;\n    height: 57px;\n    border-radius: 50%;\n}\n\n.dashboard_card:nth-child(5n+1) .stat_box.white_box {\n    background: #FFE2E5;\n}\n\n.dashboard_card:nth-child(5n+1) .stat_box.white_box span {\n    background-color: #FA5A7D;\n}\n\n.dashboard_card:nth-child(5n+2) .stat_box.white_box {\n    background: #FFF4DE;\n}\n\n.dashboard_card:nth-child(5n+2) .stat_box.white_box span {\n    background-color: #FF947A;\n\n}\n\n.dashboard_card:nth-child(5n+3) .stat_box.white_box {\n    background: #DCFCE7;\n}\n\n.dashboard_card:nth-child(5n+3) .stat_box.white_box span {\n    background-color: #3CD856;\n\n}\n\n.dashboard_card:nth-child(5n+4) .stat_box.white_box {\n    background: #F3E8FF;\n}\n\n.dashboard_card:nth-child(5n+4) .stat_box.white_box span {\n    background-color: #BF83FF;\n\n}\n\n.dashboard_card:nth-child(5n+5) .stat_box.white_box {\n    background: #c5e5ff;\n}\n\n.dashboard_card:nth-child(5n+5) .stat_box.white_box span {\n    background-color: #3799e7;\n\n}\n\n\n\n.dashboard_card .stat_box.white_box span i {\n    font-size: 25px;\n}\n\n/* .stat_box span {\n    width: 40px;\n    height: 40px;\n    border-radius: 100px;\n    background-color: #2962FF;\n    position: absolute;\n    left: 20px;\n    top: 50%;\n    transform: translate(0, -50%);\n} */\n/* .stat_box span {\n    width: 40px;\n    height: 40px;\n    border-radius: 100px;\n    background-color: #2962FF;\n    position: absolute;\n    left: 50px;\n    top: 46%;\n    transform: translate(0, -50%);\n} */\n\n/* .stat_box span i {\n    font-size: 18px;\n} */\n\n.view_dashboard {\n    background-color: #ECEFF1;\n    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);\n    border-radius: 20px;\n    padding: 27px 15px 27px 77px;\n}\n\n.view_dashboard i {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translate(0, -50%);\n    color: #455A64;\n}\n\n.view_dashboard p {\n    font-weight: 500;\n    font-size: 15px;\n    width: 90%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #455A64;\n}\n\n.targetbox h5 {\n    font-weight: 500;\n    font-size: 15px;\n    color: #455A64;\n}\n\n.view_dashboard .view_dashbard_icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 100px;\n    background-color: #fff;\n    position: absolute;\n    left: 20px;\n    top: 50%;\n    transform: translate(0, -50%);\n}\n\n.targetnum:first-child .progress {\n    background-color: #2962FF;\n}\n\n.views_target .progress {\n    background-color: #2962ff29;\n    border-radius: 100px;\n    height: 13px;\n}\n\n.progress-bar {\n    background-color: #2962FF;\n\n}\n\n.followers_target .progress {\n    background-color: #fdc10733;\n    border-radius: 100px;\n    height: 13px;\n}\n\n.followers_target .progress-bar {\n    background-color: #fdc107;\n}\n\n.income_target .progress {\n    border-radius: 100px;\n    height: 13px;\n    background-color: #fb3d005c !important;\n}\n\n.income_target .progress-bar {\n    background-color: #fb3d00 !important;\n}\n\n.meeting_box .stat_box span img {\n    width: 42px;\n    height: 42px;\n    object-fit: cover;\n    border-radius: 100%;\n}\n\n.meeting_box .stat_box span {\n    background-color: transparent;\n}\n\n.meeting_box .stat_box h5 {\n    font-size: 15px;\n    width: 85%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.meeting_box .fa-plus {\n    font-weight: 400;\n    font-size: 22px;\n    color: #232323;\n}\n\n.illustrator_img img {\n    max-width: 230px;\n    margin: auto;\n}\n\n.meeting_box .stat_box.white_box {\n    padding: 23px 15px 23px 77px;\n}\n\n.btn.action_btn i {\n    width: 43px;\n    height: 43px;\n    background-color: #0d6efd14;\n    border-radius: 100%;\n    display: inline-flex;\n    justify-content: center;\n    color: #434343;\n    align-items: center;\n    font-size: 18px;\n}\n\n.table-responsive th {\n    padding: 15px 13px !important;\n    color: #0a2e2e !important;\n    font-weight: 500;\n}\n\n.table-responsive td {\n    padding: 12px 13px !important;\n    /* text-transform: capitalize; */\n    color: #666666 !important;\n    font-size: 14px;\n}\n\n.table-striped>tbody>tr:nth-of-type(odd)>* {\n    background-color: rgba(94, 177, 191, 0.1);\n}\n\nform {\n    background-color: #fff;\n    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);\n    border-radius: 20px;\n    padding: 35px;\n}\n\nform .form-control {\n    padding: 8px 10px;\n}\n\n@media (max-width:1199px) {\n    .welcome_box h1 {\n        font-size: 28px;\n    }\n}\n\n@media (max-width:767px) {\n    .welcome_box h1 {\n        font-size: 39px;\n        line-height: unset;\n    }\n\n    .congo_box,\n    .white_box {\n        margin-bottom: 20px;\n    }\n}\n\n@media (max-width:375px) {\n    .welcome_box h1 {\n        font-size: 32px;\n    }\n\n    .congo_box,\n    .white_box {\n        margin-bottom: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
